import { render, staticRenderFns } from "./singleCardLimitHistory.vue?vue&type=template&id=a6b97430&"
import script from "./singleCardLimitHistory.vue?vue&type=script&lang=js&"
export * from "./singleCardLimitHistory.vue?vue&type=script&lang=js&"
import style0 from "./singleCardLimitHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports